// Extract keywords from description
// Helper function to clean description
export function cleanDescription(description: string): string {
  return description.replace(/^Original URL:\s*.+?(?:\n\n|$)/, '').trim()
}

// Helper function to get stop words set
export function getStopWords(): Set<string> {
  return new Set([
    'the', 'a', 'an', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'by',
    'from', 'as', 'is', 'was', 'are', 'were', 'been', 'be', 'have', 'has', 'had', 'do', 'does', 'did',
    'will', 'would', 'should', 'could', 'may', 'might', 'must', 'can', 'this', 'that', 'these', 'those',
    'i', 'you', 'he', 'she', 'it', 'we', 'they', 'me', 'him', 'her', 'us', 'them',
    'what', 'which', 'who', 'whom', 'whose', 'where', 'when', 'why', 'how',
    'all', 'each', 'every', 'both', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not',
    'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', 'should', 'now'
  ])
}

// Helper function to extract words from description
export function extractWords(description: string, stopWords: Set<string>): string[] {
  return description
    .toLowerCase()
    .replace(/[^\w\s]/g, ' ')
    .split(/\s+/)
    .filter(word => word.length >= 2 && !stopWords.has(word))
}

// Helper function to count word frequency
export function countWordFrequency(words: string[]): Record<string, number> {
  const wordCount: Record<string, number> = {}
  words.forEach(word => {
    wordCount[word] = (wordCount[word] || 0) + 1
  })
  return wordCount
}

// Helper function to convert word count to sorted array
export function sortWordsByFrequency(wordCount: Record<string, number>, limit = 50): Array<{ word: string; count: number }> {
  return Object.entries(wordCount)
    .map(([word, count]) => ({ word, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, limit)
}

export function extractKeywords(description: string | undefined): Array<{ word: string; count: number }> {
  try {
    if (!description || typeof description !== 'string') return []
    
    const cleanedDescription = cleanDescription(description)
    if (!cleanedDescription) return []

    const stopWords = getStopWords()
    const words = extractWords(cleanedDescription, stopWords)
    const wordCount = countWordFrequency(words)
    return sortWordsByFrequency(wordCount)
  } catch (error) {
    return []
  }
}
